import React from 'react';
import { isEmail } from '../../helpers/validators';
import Button from '../Button';
import Text from '../Text';
import StateHeading from './StateHeading';
import { DataModelV2UpgradeModalProps } from './types';

type Props = { title: string; email: string } & Pick<
  DataModelV2UpgradeModalProps,
  'actionPending' | 'onRetry' | 'onContactSupport'
>;

export default function Failure({ title, email, actionPending, onRetry, onContactSupport }: Props) {
  return (
    <>
      <StateHeading title={title}>
        Something went wrong during the migration, so we restored your account from the backup. Nothing about
        your data has changed.
      </StateHeading>
      <section className="space-y-3 rounded-lg bg-sub p-6 sm:p-12">
        <Text as="div" variant="base" role="heading" aria-level={3} className="text-2xl font-semibold">
          We’re on it
        </Text>
        <Text as="p" variant="muted" className="leading-6">
          Our team has been notified automatically and we'll look into it.
          {isEmail(email) && (
            <>
              {' '}
              You can try again now, or wait for us to reach out at{' '}
              <Text variant="base" className="break-words">
                {email}
              </Text>
              .
            </>
          )}
        </Text>
      </section>
      <div className="grid grid-cols-2 gap-4">
        <Button type="button" variant="secondary" fullWidth onClick={onContactSupport}>
          Contact Support
        </Button>
        <Button
          type="button"
          variant="primary"
          fullWidth
          loading={actionPending}
          disabled={actionPending}
          onClick={onRetry}
        >
          Try again
        </Button>
      </div>
    </>
  );
}
